import React, { useEffect } from "react";
import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Categories from "./home-categories/Categories";
import Serving_love from "./serving-love/Serving_love";
import Why_choose_us from "./why-choose-us/Why_choose_us";
import Offer from "./offer/Offer";
import Special_features from "./special-features/Special_features";
import Download_app from "./download-app/Download_app";
import Local_Connect_Intro from "./local_connect_intro/Local_Connect_Intro";
import What_You_Can_Find from "./what_you_can_find/What_You_Can_Find";
import For_Citizens from "./for_citizens/For_Citizens";
import Grow_Your_Local_Reach from "./grow_your_local_reach/Grow_Your_Local_Reach";
import Why_People_Trust_Us from "./why_people_trust_us/Why_People_Trust_Us";
import VisionSection from "./vision_section/Vision_Section";
import Local_Benefits from "./local_benefits/Local_Benefits";

function Home() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Banner />
      <Local_Connect_Intro/>
      <What_You_Can_Find />
      <For_Citizens/>
      <Grow_Your_Local_Reach/>
      <Why_People_Trust_Us/>
      <VisionSection/>
      <Local_Benefits/>

      {/* <Categories />
      <Serving_love />
      <Why_choose_us />
      <Offer />
      <Special_features />
      <Download_app /> */}
    </>
  );
}

export default Home;
